import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AiChat } from 'src/@types/ai';
import { AIRequests } from 'src/requests/ai';
import { QueryKey } from 'src/utils/react-query';

export const useConversationDeleteMutation = () => {
  const client = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (conversationId: string) =>
      AIRequests.deleteConversation(conversationId),
    onSuccess: (data) => {
      client.setQueryData<AiChat[]>([QueryKey.AI_CHATS], (chats = []) =>
        chats.filter((c) => c._id !== data._id),
      );
    },
  });

  return {
    deleteConversation: mutateAsync,
    isDeletingConversation: isLoading,
  };
};
